module.exports = __webpack_public_path__ + "img/save-circle.3dd18976.svg";